import * as React from 'react';
import { createContext } from 'react';
import IConfig from '@sitegen/common/constants/config';
import { ConfigContextProps, ConfigContextProviderProps } from './config-context.types';

const defaultContext: ConfigContextProps = {
    getModeClass: className => className,
    config: {} as IConfig
};

const createGetModeClassFunction = ( shouldInheritStyles: boolean = false): (className: string) => string => {
    return shouldInheritStyles ? (className) => `${className}-embedded` : (className) => (className);
};

export const ConfigContext = createContext<ConfigContextProps>(defaultContext);

const ConfigContextProvider = (props: ConfigContextProviderProps) => {
    return <ConfigContext.Provider value={{
        getModeClass: createGetModeClassFunction(props.config?.shouldInheritStyles),
        config: props.config
    }}>
        {props.children}
    </ConfigContext.Provider>;
};

export default ConfigContextProvider;
